// @flow
import styled from "styled-components"
import { Wrap } from "componentsStyled/Layout/Wrap"
import { Text } from "componentsStyled/Typography/Texts"

export const EnumFilterWrap = styled(Wrap)`
  display: flex;
  justify-content: space-between;
`

export const TextWrapper = styled(Text)`
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`



// WEBPACK FOOTER //
// ./src/modals/SetActivityFilters/ActivityFilters/EnumFilter/styled.js